import React from "react";
import { cn } from "@/lib/utils";
import { StepConfig } from "@/hooks/use-multi-step";

interface StepIndicatorProps {
  steps: StepConfig[];
  currentStep: number;
  completedSteps?: Set<number>;
  onStepClick?: (step: number) => void;
  allowClickNavigation?: boolean;
  stepsWithErrors?: Set<number>;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  steps,
  currentStep,
  onStepClick,
  allowClickNavigation = false,
  stepsWithErrors = new Set(),
}) => {
  return (
    <div className="w-full">
      <div className="w-full">
        <div
          className="flex items-center rounded-md p-1 w-full"
          style={{
            height: "40px",
            backgroundColor: "#F6F2E7",
            borderRadius: "6px",
            padding: "4px",
            flexShrink: 0,
          }}
        >
          {steps.map((step, index) => {
            const isCurrent = index === currentStep;
            const hasError = stepsWithErrors.has(index);

            return (
              <button
                key={step.id}
                type="button"
                className={cn(
                  "flex-1 py-1.5 text-sm font-medium rounded transition-all duration-200 h-8 flex items-center justify-center relative",
                  {
                    "bg-white text-gray-900 shadow-sm": isCurrent && !hasError,
                    "bg-red-50 text-red-700 shadow-sm border border-red-200":
                      isCurrent && hasError,
                    "text-gray-600 hover:text-gray-900 hover:bg-gray-50":
                      !isCurrent && allowClickNavigation && !hasError,
                    "text-red-600 hover:text-red-700 hover:bg-red-50 border border-red-200":
                      !isCurrent && allowClickNavigation && hasError,
                    "text-gray-500":
                      !isCurrent && !allowClickNavigation && !hasError,
                    "text-red-500 border border-red-200 bg-red-50":
                      !isCurrent && !allowClickNavigation && hasError,
                    "cursor-pointer": allowClickNavigation,
                    "cursor-default": !allowClickNavigation,
                  },
                )}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (allowClickNavigation && onStepClick) {
                    onStepClick(index);
                  }
                }}
              >
                {step.title}
                {hasError && (
                  <span className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full"></span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
